/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import "@hotwired/turbo-rails";
import "./jquery-import";
import "jquery-validation";
import "slick-carousel";
import "./shared/slick-turbo-cache";

import "./shared/fontawesome-imports";
// import "javascripts/header";
import "./frontpage/nav";
import "./content-page";
import "./product-page";
import "./frontpage/stageslider";
import "./frontpage/facts";
import "./frontpage/video";
import "./frontpage/blogs";
import "./frontpage/tabs";
import "./frontpage/press";
import "./flash-message-close";
import "./frontpage/single-gallery-slider";
import "./contact/contact";
import "./contact/new";
import "./contact/steps/request-reason";
import "./contact/steps/upload-file";
import "./contact/steps/link-to-job";
import "./contact/steps/qualification";
import "./contact/steps/motivation";
import "./contact/steps/language";
import "./gallery-image-container/gallery-image-container-slider";
import "./backend/editor";
import "./shared/mailcheck";
import "./shared/smoothscroll";
import "./cv_parser/draganddrop";
import "./cv_parser/overlay";
